import React, { useEffect, useState } from "react";
import PermissionsGate from "../../../../../utils/permissionGate";

function PMCAlreadyEnrolled(props) {
    const {
        failedModules,
        selectedData,
        allModules,
        setAdminCreditModulesIds,
        adminCreditModulesIds,
        readOnly
    } = props;
    
    const handleAdd = (id) => {
        setAdminCreditModulesIds(prev => [...prev, String(id)]);
    }
    //   // Handle change in dropdown selection
    //   function handleSubjectChange(event, idx) {
    //     let updatedFields = [...fields]; // Copy fields array
    //     updatedFields[idx] = event.target.value; // Update the value at the specific index
    //     setFields(updatedFields); // Update the fields state
    
    //     // Update selected values in adminModules state
    //     setAdminModules(updatedFields.filter(value => value !== ""));
    //   }
    
    //   // Add a new dropdown
    //   function handleAdd() {
    //     setFields([...fields, ""]); // Add an empty field to the array
    //   }
    
    //   // Remove a dropdown at index i
    //   function handleRemove(i) {
    //     const updatedFields = [...fields];
    //     if (updatedFields.length > 1) {
    //       updatedFields.splice(i, 1); // Remove the field at index i
    //       setFields(updatedFields); // Update the fields state
    //       setAdminModules(updatedFields);
    //     }
    //   }
    // console.log("selectedData", selectedData);
    // console.log("selectedData?.required", selectedData?.required);

    return (
        <React.Fragment>    
        {selectedData && (
            <React.Fragment>
            <h5 className="heading-5 mt-30">Current Enrollment
            </h5>
            
            <div className="mb-2 mt-3">
            <div className="row align-items-center">
            <div className="col-sm-12 mt-2">       
            <div className="row align-items-center">
            <div className="col-sm-6">
            { failedModules && failedModules?.length > 0 && 
            (<>
            {failedModules?.map((failedModule) => 
            String(failedModule?.module_id)
            .split(',')
            .map((id) => {
                const module = allModules?.[Number(id)];
                return (
                    <React.Fragment key={id}>
                    <span key={id} value={id}>
                    {module?.name} ({module?.Code}) - Semester {module?.term} - Status: <span className="redText">FAIL</span> 
                    </span>
                    <br/>
                    <br/>
                    </React.Fragment>
                );
            }))}
            </>)            
        }
        {selectedData?.required?.map((id) => {
            const module = allModules?.[id];
            return (
                <React.Fragment key={id}>
                <span key={id} value={id}>
                {module?.name} ({module?.Code}) - Semester {module?.term} - Status: <span className={adminCreditModulesIds.includes(String(module?.netsuite_product_id)) ? "greyText" : module?.status == "ENROLLED" ? "blueText" :  "greenText"}> {adminCreditModulesIds.includes(String(module?.netsuite_product_id)) ? "PENDING DE-REGISTRATION" : module?.status}</span>&nbsp;
                {!readOnly && module?.status === "ENROLLED" && !adminCreditModulesIds.includes(String(module?.netsuite_product_id)) && (
                    <PermissionsGate scopes={['RegPMCSelectionEdit']} errorProps={{ disabled: true }}>
                    <button title="De-Register Module" className="btn btn-primary rounded-circle"
                    onClick={() => handleAdd(module?.netsuite_product_id)} 
                    >
                    <i className="fa-light fa-user-minus"></i>
                    </button>
                    </PermissionsGate>
                )}
                </span>
                <br/>
                <br/>
                </React.Fragment>
            );
        })}
        {selectedData?.elective?.map((id) => {
            const module = allModules?.[id];
            return (
                <React.Fragment key={id}>
                <span key={id} value={id}>
                {module?.name} ({module?.Code}) - Semester {module?.term} - Status: <span className={adminCreditModulesIds.includes(String(module?.netsuite_product_id)) ? "greyText" : module?.status == "ENROLLED" ? "blueText" :  "greenText"}> {adminCreditModulesIds.includes(String(module?.netsuite_product_id)) ? "PENDING DE-REGISTRATION" : module?.status}</span>&nbsp;
                {!readOnly && module?.status === "ENROLLED" && !adminCreditModulesIds.includes(String(module?.netsuite_product_id)) && (
                    <PermissionsGate scopes={['RegPMCSelectionEdit']} errorProps={{ disabled: true }}>
                    <button title="De-Register Module" className="btn btn-primary rounded-circle"
                    onClick={() => handleAdd(module?.netsuite_product_id)} 
                    >
                    <i className="fa-light fa-user-minus"></i>
                    </button>
                    </PermissionsGate>
                )}
                </span>
                <br/>
                <br/>
                </React.Fragment>
            );
        })}            
        </div>  
        </div>                                           
        </div>
        </div>
        <br/>   
        </div>         
        </React.Fragment>
    )}
    
    </React.Fragment>
);
}

export default PMCAlreadyEnrolled;
